import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

const CardIconButtonWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => `${utils.rem(theme.Spacing.Size.XSmall)}`};
  border-radius: ${({ theme }) => `${utils.rem(theme.Card.Radius.Small)}`};
  background: ${({ theme }) => `${theme.Color.NeutralsFixed.Gray}`};
  height: ${({ theme }) => `${utils.rem(theme.Spacing.Size.Large)}`};
  width: ${({ theme }) => `${utils.rem(theme.Spacing.Size.Large)}`};
  transition: opacity 0.5s ease-in-out;
  align-self: center;
`;

export const CardIconButtonStyles = {
  CardIconButtonWrapper,
};
